export default {
  'funnel:cart-box:questions': 'Heb je vragen over je bestelling?',
  'funnel:cart-box:call': 'Bel ons gerust!',
  'funnel:cart-box:phone-number': '{phone}',
  'funnel:cart-box:opening-hours': 'Ma-vr 9-18 uur',
  'funnel:configurator:modal-title': 'Stel het product zo samen als het jou het beste uitkomt',
  'funnel:configurator:most-popular': 'Meest populair',
  'funnel:configurator:add-to-cart': 'Toevoegen aan winkelwagen',

  'funnel:configurator:confirm-selection': 'Keuze bevestigen',
  'funnel:configurator:one-off-price': 'Prijs voor eenmalige levering',
  'funnel:configurator:subscription-price': 'Prijs voor regelmatige levering',
};
